import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { formSchema } from 'forms/customerForm';
import { validateSchema } from 'utils/schemaUtil';
import { Layout, Typography, IconButton, TextFieldReduxFormWrapper } from '@hub-mono/ui';

class CreateCustomer extends PureComponent {
    static propTypes = {
        formName: PropTypes.string,
        fieldName: PropTypes.string,
        onDismiss: PropTypes.func,
    };

    static defaultProps = {
        formName: '',
        fieldName: '',
        onDismiss: null,
    };

    onSubmit() {
        this.props.submitForm();
        if (this.props.valid) {
            if (this.props.onDismiss) {
                setTimeout(this.props.onDismiss);
            }
        }
    }

    render() {
        return (
            <Layout stack gap="--Spacing-150">
                <Typography variant="label" size="large">
                    Add New Client:
                </Typography>
                <Layout gap="--Spacing-150">
                    <Field
                        name="name"
                        placeholder="Type the name of the new Client here..."
                        helperText="Enter the name of a new Client"
                        component={TextFieldReduxFormWrapper}
                    />
                    <Layout>
                        <IconButton icon="check" onClick={this.onSubmit.bind(this)} />
                        <IconButton icon="delete" onClick={this.props.onDismiss} />
                    </Layout>
                </Layout>
            </Layout>
        );
    }
}

export default reduxForm({
    form: 'customerForm',
    validate: validateSchema(formSchema),
})(CreateCustomer);
